import { DEVICE_ROLES } from '@/features/core/container';
import { MetricResolutionAggregator, MetricResolutionTimeSource, SpotRole } from '@/types/iot-portal';
import { option } from '@/util/container';
import { component } from '../component';
import lg from './section-meter-heat-meter-counter-lg.svg';
import md from './section-meter-heat-meter-counter-md.svg';
import sm from './section-meter-heat-meter-counter-sm.svg';

export default option(DEVICE_ROLES, async () => ({
  name: SpotRole.SECTION_METER_HEAT_METER_COUNTER,
  label: 'Zwischenzähler_Wärmemengenzähler',
  shortLabel: 'Zs_WMZ',
  icons: { sm, md, lg },
  component: component('section-meter-heat-meter-counter/SectionMeterHeatMeterCounterDevicePanel.vue'),
  aggregationWidget: {
    enabled: true,
    component: component('section-meter-heat-meter-counter/SectionMeterHeatMeterCounterAggregationWidget.vue'),
  },
  defaultMetricNames: ['currentEnergy'],
  importantMetricNames: ['currentEnergy', 'currentFlow', 'currentVolume'],
  consumption: true,
  aggregationMetricNames: [
    {
      name: 'currentEnergy',
      aggregators: [MetricResolutionAggregator.MEAN],
      timeSource: MetricResolutionTimeSource.START,
    },
    {
      name: 'currentFlow',
      aggregators: [MetricResolutionAggregator.MEAN],
      timeSource: MetricResolutionTimeSource.START,
    },
  ],
}));
